import React from 'react'

function Footer1() {
  return (
   <>
   <footer class="text-gray-600 body-font bg-[#1c1b1f]">
  <div class="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
    <div class="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
      <a class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
       <img src='' alt='carrerconnect'></img>
        <span class="ml-3 text-xl">CarrerConnect</span>
      </a>
      
    </div>
    <div class="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">
      <div class="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">CATEGORIES</h2>
        <nav class="list-none mb-10">
        <h4 class="text-white font-semibold">Support</h4>
            <ul class="text-white space-y-7">
                <li><a href="#">ContactUs</a></li>
                <li><a href="#">Customer Support</a></li>
                <li><a href="#">Connect4All Status</a></li>
                <li><a href="#">Manage Cookies</a></li>
            </ul>
        </nav>
      </div>
      <div class="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">CATEGORIES</h2>
        <nav class="list-none mb-10">
        <h4 class="text-white font-semibold">Support</h4>
            <ul class="text-white space-y-7">
                <li><a href="#">ContactUs</a></li>
                <li><a href="#">Customer Support</a></li>
                <li><a href="#">Connect4All Status</a></li>
                <li><a href="#">Manage Cookies</a></li>
            </ul>
        </nav>
      </div>
      <div class="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">CATEGORIES</h2>
        <nav class="list-none mb-10">
        <h4 class="text-white font-semibold">Support</h4>
            <ul class="text-white space-y-7">
                <li><a href="#">ContactUs</a></li>
                <li><a href="#">Customer Support</a></li>
                <li><a href="#">Connect4All Status</a></li>
                <li><a href="#">Manage Cookies</a></li>
            </ul>
        </nav>
      </div>
      <div class="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">CATEGORIES</h2>
        <nav class="list-none mb-10">
        <h4 class="text-white font-semibold">Social Media</h4>
            <ul class="text-white  space-y-7 ">
                <li className='flex space-x-3'><img src="https://cdn-icons-png.freepik.com/256/10090/10090288.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid" height={"20px"} width={"25px"}/><a href="#">Github</a></li>
                <li className='flex space-x-3'><img src='https://cdn-icons-png.freepik.com/256/16327/16327169.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid' height={"20px"} width={"25px"}/><a href="#">Indeed</a></li>
                <li className='flex space-x-3'><img src='https://cdn-icons-png.freepik.com/256/2504/2504923.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid' height={"20px"} width={"25px"} /><a href="#">LinkedIn</a></li>
                <li className='flex space-x-3'><img src='https://cdn-icons-png.freepik.com/256/2504/2504934.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid' height={"20px"} width={"25px"}/><a href="#">Reddit</a></li>
                <li className='flex space-x-3'><img src='https://cdn-icons-png.freepik.com/256/2504/2504918.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid' height={"20px"} width={"25px"}/><a href="#">Instagram</a></li>
                <li className='flex space-x-3'><img src='https://cdn-icons-png.freepik.com/256/889/889226.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid' height={"20px"} width={"25px"}/><a href="#">Twitch</a></li>
                <li className='flex space-x-3'><img src='https://cdn-icons-png.freepik.com/256/2584/2584684.png?ga=GA1.1.2115079256.1724344357&semt=ais_hybrid' height={"20px"} width={"25px"}/><a href="#">Slack</a></li>
                
            </ul>
        </nav>
      </div>
    </div>
  </div>
  <div class="bg-zinc-900">
    <div class="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
      <p class="text-gray-500 text-sm text-center sm:text-left">© 2024 CarrerConnect—
        <a href="https://twitter.com/knyttneve" rel="noopener noreferrer" class="text-gray-600 ml-1" target="_blank">@knyttneve</a>
      </p>
      <span class="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
        <a class="text-gray-500">
          <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
            <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
          </svg>
        </a>
        <a class="ml-3 text-gray-500">
          <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
            <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
          </svg>
        </a>
        <a class="ml-3 text-gray-500">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
          </svg>
        </a>
        <a class="ml-3 text-gray-500">
          <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0" class="w-5 h-5" viewBox="0 0 24 24">
            <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
            <circle cx="4" cy="4" r="2" stroke="none"></circle>
          </svg>
        </a>
      </span>
    </div>
  </div>
</footer>
   </>
  )
}

export default Footer1